(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[376,673],{

/***/ 237:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/[slug]",
      function () {
        return __webpack_require__(9544);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 26:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _lib_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4327);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function Image(props, ref) {
    const { alt , loading , src , ...rest } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        ref: ref,
        srcSet: (0,_lib_image__WEBPACK_IMPORTED_MODULE_1__/* .buildSrcSet */ .fY)(src),
        src: (0,_lib_image__WEBPACK_IMPORTED_MODULE_1__/* .buildImageUrl */ .Sc)(src.url),
        ...rest,
        alt: alt || "",
        decoding: "async",
        loading: loading || "lazy"
    });
}));


/***/ }),

/***/ 9673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ImageSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2606);
/* harmony import */ var _lib_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(608);
/* harmony import */ var _components_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26);




function ImageSection(param) {
    let { data: { image  }  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        size: _lib_types__WEBPACK_IMPORTED_MODULE_2__/* .ContainerSize.wide */ .B.wide,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "lg:grid grid-cols-12 gap-1.5 md:gap-6",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "col-start-3 col-span-8",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    className: "w-full rounded-xl md:rounded-3xl",
                    src: image,
                    height: image.height,
                    width: image.width,
                    alt: image.alternativeText,
                    sizes: "100vw"
                })
            })
        })
    });
}


/***/ }),

/***/ 9960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ parseDate; }
/* harmony export */ });
const options = {
    month: "long",
    day: "numeric",
    year: "numeric",
    timeZone: "Europe/Zurich"
};
/**
 * Will format dates and render a string like "January 1, 2020"
 * Note: that the time is set to 1am in switzerland. This is not correct for news.
 * News should be saved with a time because a news article published on Jan 1 at 10am
 * is published on the the 31st of December from a US perspective.
 */ function parseDate(date) {
    return new Intl.DateTimeFormat("en-US", options).format(new Date(date).setUTCHours(1, 0, 0, 0));
}


/***/ }),

/***/ 9544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ NewsPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2606);
/* harmony import */ var _components_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1046);
/* harmony import */ var _components_sections__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3427);
/* harmony import */ var _components_sections_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9673);
/* harmony import */ var _components_seo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4169);
/* harmony import */ var _components_structured_data__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6269);
/* harmony import */ var _lib_date__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9960);
/* harmony import */ var _lib_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(608);









var __N_SSP = true;
function NewsPage(param) {
    let { isPreview , news , menu , menuFooter , menuFooterSecondary , settings , url  } = param;
    var _news_locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        isPreview: isPreview,
        menu: menu,
        menuFooter: menuFooter,
        menuFooterSecondary: menuFooterSecondary,
        settings: settings,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_seo__WEBPACK_IMPORTED_MODULE_5__/* .Seo */ .p, {
                title: news.title,
                url: url,
                seo: news.seo
            }),
            settings.website && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_structured_data__WEBPACK_IMPORTED_MODULE_6__/* .WebPageJsonLd */ .VL, {
                        url: url,
                        title: news.title,
                        locale: (_news_locale = news.locale) !== null && _news_locale !== void 0 ? _news_locale : undefined,
                        seo: news.seo,
                        website: settings.website
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_structured_data__WEBPACK_IMPORTED_MODULE_6__/* .NewsArticleJsonLd */ .TE, {
                        news: news,
                        url: url,
                        website: settings.website
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_structured_data__WEBPACK_IMPORTED_MODULE_6__/* .EventsJsonLd */ .pv, {
                sections: news.content
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                size: _lib_types__WEBPACK_IMPORTED_MODULE_8__/* .ContainerSize.wide */ .B.wide,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "grid grid-cols-12 gap-10",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "text-32 md:text-35 leading-130 font-bold text-blue-800 col-start-2 col-span-11 lg:col-start-4 lg:col-span-6",
                            children: news.title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-17 leading-140 md:text-20 md:leading-124 text-iceblue-500 font-bold col-start-2 col-span-11 lg:col-start-4 lg:col-span-6",
                            children: (0,_lib_date__WEBPACK_IMPORTED_MODULE_7__/* .parseDate */ .s)(news.publishDate)
                        }),
                        news.intro && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "col-start-2 col-span-11 lg:col-start-4 lg:col-span-6 prose",
                            children: news.intro
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_sections_image__WEBPACK_IMPORTED_MODULE_4__["default"], {
                data: {
                    image: news.image
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_sections__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                sections: news.content,
                settings: settings
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [446,46,266,774,888,179], function() { return __webpack_exec__(237); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);